// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { patch, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { CreateQuoteApiParameter } from "@insite/client-framework/Services/QuoteService";
import { CartModel, QuoteModel } from "@insite/client-framework/Types/ApiModels";

const quotesUrl = "/api/v1/carts/current";

export async function createQuoteAsOrder(
    createQuoteParameter: CreateQuoteApiParameter,
): Promise<ServiceResult<CartModel>> {
    try {
        const cartModel = await patch<CartModel>(quotesUrl, createQuoteParameter as any);
        return {
            successful: true,
            result: cartModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
